module.exports = __webpack_public_path__ + "static/zama-1-0feb81223a24218990df32b1f26b6db6.gif";